<script setup lang="ts">

import { useViewModelInstance } from "@app/MyGarage";
import { ConfigureConditionViewModel, ConfigureConditionHeader, ConfigureService, ConfigureWeekly, ConfigurePreviousMonth, ConfigureFutureMonth, ConfigureSpecificDate, ConfigureCritical } from ".";
import { ConfigurationType, ConditionType } from "@domain/Vehicle";
    
type Props = {
    conditionType: ConditionType
}
const { conditionType } = defineProps<Props>();

const model = await useViewModelInstance();
const condition = model.vehicle.condition.getCondition( conditionType )!;
const viewModel = new ConfigureConditionViewModel( condition, model.vehicle );

console.log( condition.labels.name, condition.configurationType )
</script>

<template>
 
    <div class="w-full h-full overflow-y-auto flex flex-col">

        <div class="w-full">

            <!-- SERVICE TYPE HAS ITS OWN CONFIGURATION -->
            <template v-if="condition.type == ConditionType.Service">
                <ConfigureService v-model="viewModel" />
            </template>
            
            <!-- WE DONT HAVE ANY DATA FOR A SETTING THAT TAKES A FUTURE MONTH -->
            <!-- CONFIGURE FROM PREVIOUS MONTH AND ADD THE CONDITIONS INTERVAL -->
            <template v-else-if="condition.configurationType == ConfigurationType.Monthly && condition.hasData == false">
                <ConfigurePreviousMonth v-model="viewModel" />
            </template>
            
            <!-- CONFIGURE TO FUTURE MONTH -->
            <template v-else-if="condition.configurationType == ConfigurationType.Monthly">
                <ConfigureFutureMonth v-model="viewModel" />
            </template>

            <!-- CONFIGURE TO FUTURE WEEK -->
            <template v-else-if="condition.configurationType == ConfigurationType.Weekly">
                <ConfigureWeekly v-model="viewModel" />
            </template>

            <!-- CONFIGURE TO SPECIFIC DATE -->
            <template v-else-if="condition.configurationType == ConfigurationType.Date">
                <ConfigureSpecificDate v-model="viewModel" />
            </template>

        </div>  

    </div>

</template>
